module.exports = __webpack_public_path__ + "img/home2.b15c20cb.png";